
import {defineComponent, PropType} from "vue";
import {formatDate} from "@/helpers/functions/date";
import {StatusEnum} from "@/api/enums/status-enum";
import {CodeDescriptionRestDto} from "@/api/pharma-cpc-mgmt/models";
import {NotificationTemplateOverviewRestDto} from "@/api/pharma-master-notification-template/models";
import {FormMixin} from "@/components/base/FormMixin";
import {CommTypeEnum} from "@/api/enums/comm-type-enum";
import {EnumRestService} from "@/services/rest/enum/EnumRestService";
import {NotificationTemplateMixin} from "@/components/layouts/notification-template/NotificationTemplateMixin";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";
import {UIStateDto} from "@/dtos/UIStateDto";

export default defineComponent({
  name: "NotificationTemplateOverviewItem",
  mixins: [FormMixin, NotificationTemplateMixin],
  components: { BaseDeleteButton },
  emits: ["update", "delete"],
  props: {
    template: {
      type: Object as PropType<NotificationTemplateOverviewRestDto>,
      required: true,
    },
    parentPageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    },
    moduleCode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      allNotificationTypes: [] as CodeDescriptionRestDto[],
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
  },
  computed: {
    StatusEnum() {
      return StatusEnum
    },
    notificationType(): string {
      return this.allNotificationTypes
        .find((typeCode: any) => typeCode.code === this.template.type_code)
        ?.description ?? this.template.type_code;
    },
    communicationType(): string {
      if (this.template.comm_type_code === CommTypeEnum.EMAIL) {
        return this.$t('email');
      }
      return this.$t('sms');
    }
  },
  methods: {
    formatDate,
    async doInitialize(): Promise<void> {
      this.allNotificationTypes = await EnumRestService.getInstance()
        .getEnumValuesByClassName(this.getNotificationTypeEnum(this.moduleCode), this.moduleCode);
    },
    async doReload() {
      // Do nothing
    }
  }
});
